import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="1.74394" cy="1.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
      <ellipse cx="1.74394" cy="6.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
      <ellipse cx="1.74394" cy="11.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
      <ellipse cx="6.83378" cy="1.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
      <ellipse cx="6.83378" cy="6.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
      <ellipse cx="6.83378" cy="11.5" rx="1.52714" ry="1.5" fill="#C4C4C4"/>
    </svg>
  )
}

export default Icon
